.superAdminAndLogoContainer {
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 12px;

  .superAdminContainer {
    position: relative;
    margin-left: 2px;

    @include mobile() {
      display: none;
    }
  }

  > a {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
  }

  .logo {
    cursor: default;
    width: 36px;
    height: 36px;
    margin-left: 2px;

    @include themify($themes) {
      color: themed("brand-primary");
    }

    &:hover {
      cursor: pointer;
    }
  }
}

.searchOrg {
  svg {
    height: 6px;
    width: 12px;
  }
}

.searchContainer {
  min-width: 250px;
  border-radius: 22px;
  display: flex;
  align-items: center;
  position: relative;
  > svg {
    position: absolute;
    cursor: auto;
    left: 12px;
    top: 50%;
    transform: translate(0, -50%);
    z-index: 9999999;
    opacity: 0.5;
    width: 18px;
    height: 18px;
    margin-left: 5px;
  }
  @include themify($themes) {
    border: solid 1px themed("neutral-secondary");
  }

  > div > div {
    height: unset !important;
  }

  > div > div > div > div:nth-child(2) > div {
    padding: 0;
  }

  > div > div > div > div > div {
    font-weight: 500;
    font-size: 15px;
  }

  [data-value] {
    padding: 0;
  }
}

.selectControl {
  padding-left: 32px;
  border-radius: 22px;
  min-height: unset !important;
}

.orgOption {
  .subLabel {
    opacity: 0.6;
    font-weight: normal;
    font-size: 14px;
  }
}
